import {
  addToCart,
  deleteCartItem,
  getCartList,
  updateCartItem,
} from "@/requests/cart";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { asyncThunkHandler } from "../reducers";

interface CartState {
  items: CartItem[];
  count: number;
  isLoading: boolean;
  error: string | null;
  draftRequest: AddToCartRequest | null;
  cartPopupOpen: boolean;
}

const initialState: CartState = {
  items: [],
  count: 0,
  isLoading: false,
  error: null,
  draftRequest: null,
  cartPopupOpen: false,
};

// ** reducers
const cartPending = (state: CartState) => {
  state.isLoading = true;
  state.error = null;
};
const cartRejected = (state: CartState, action: any) => {
  state.isLoading = false;
  state.error = action.payload;
};

// add to cart async thunk
export const addToCartAsync = asyncThunkHandler<AddToCartRequest, CartItem>(
  "cart/addToCart",
  addToCart
);
// update cart item async thunk
export const updateCartItemAsync = asyncThunkHandler<
  UpdateCartItemRequest,
  CartItem
>("cart/updateCartItem", updateCartItem);
// delete cart item async thunk
export const deleteCartItemAsync = asyncThunkHandler<number, CartItem>(
  "cart/deleteCartItem",
  deleteCartItem
);
// get cart list async thunk
export const getCartListAsync = asyncThunkHandler<void, CartItem[]>(
  "cart/getCartList",
  getCartList
);

// ** cart slice
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setDraftRequest: (
      state,
      action: PayloadAction<AddToCartRequest | null>
    ) => {
      state.draftRequest = action.payload;
    },
    setCartPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.cartPopupOpen = action.payload;
    },
    clearCart: (state) => {
      state.items = [];
      state.count = 0;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    // ** add to cart
    builder.addCase(addToCartAsync.pending, cartPending);
    builder.addCase(addToCartAsync.fulfilled, (state, action) => {
      state.isLoading = false;

      // if (!((action.payload?.Success) as any)) {
      //   state.error = action.payload?.Message || 'Failed to add to cart';
      // }

      // console.log(JSON.parse(JSON.stringify(state)));


      if (state.items.find((item) => item.id === action.payload.id)) {
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id
        );
        state.items[index] = action.payload;
      } else {
        state.items.push(action.payload);
        state.count++;
      }
    });
    builder.addCase(addToCartAsync.rejected, cartRejected);

    // ** update cart item
    builder.addCase(updateCartItemAsync.pending, cartPending);
    builder.addCase(updateCartItemAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      const index = state.items.findIndex(

        
        (item) => item.id === action.payload.id
      );
      state.items[index] = action.payload;
    });
    builder.addCase(updateCartItemAsync.rejected, cartRejected);

    // ** delete cart item
    builder.addCase(deleteCartItemAsync.pending, cartPending);
    builder.addCase(deleteCartItemAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      const index = state.items.findIndex(
        (item) => item.id === action.payload.id
      );
      state.items.splice(index, 1);
      state.count--;
    });
    builder.addCase(deleteCartItemAsync.rejected, cartRejected);

    // ** get cart list
    builder.addCase(getCartListAsync.pending, cartPending);
    builder.addCase(getCartListAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.items = action.payload;
      state.count = action.payload?.length;
    });
    builder.addCase(getCartListAsync.rejected, cartRejected);
  },

  


});

export const { setDraftRequest, setCartPopupOpen, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;
